import { defineAsyncComponent } from 'vue'
import NtLoader from './components/general/NtLoader.vue'
import NtModuleError from './components/general/NtModuleError.vue'
import { useSystemStore } from './stores/system'

export default {
  install: (app) => {
    // Explicit manual async components
    const manual = {
      NtWysiwyg: () => import('./components/forms/NtWysiwyg.vue')
    }
    for (const key in manual) {
      app.component(
        key,
        defineAsyncComponent({
          loader: manual[key],
          loadingComponent: NtLoader,
          errorComponent: NtModuleError
        })
      )
    }

    // All modules are async
    const modules = import.meta.glob('./modules/**/*.vue')
    for (const path in modules) {
      const name = path.match(/\/([A-z]+).vue$/i)
      if (!name || name.length < 2) {
        continue
      }
      app.component(
        name[1],
        defineAsyncComponent({
          loader: modules[path],
          loadingComponent: NtLoader,
          errorComponent: NtModuleError
        })
      )
    }

    // Function to link to a module page
    app.config.globalProperties.$routeToModule = (name, params, query) => {
      const store = useSystemStore()
      const route = store.routes.find((r) => r.modules.find((m) => m.component === name))
      if (!route) {
        console.warn(`Cannot link to module "${name}". It is not included on any page on the admin hub.`)
        return null
      }

      let url = app.config.globalProperties.$router.resolve({
        name: `page.${route.id}`,
        params
      })?.fullPath

      if (query) {
        const params = new URLSearchParams(query)
        url += `?${params}`
      }

      return url
    }

    app.config.globalProperties.$routeToPage = (id) => {
      if (!id) {
        return null
      }

      const store = useSystemStore()
      const route = store.routes.find((r) => r.id === id)
      if (!route) {
        return null
      }

      const usesModels = route.modules.filter((m) => m.model !== null).length > 0
      if (usesModels) {
        return null
      }

      return app.config.globalProperties.$router.resolve({
        name: `page.${id}`
      })?.fullPath
    }
  }
}
